import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { UploadCustomerDocumentDTO } from './document.interface';
import { DocumentService } from './document.service';

const service = new DocumentService();

export interface DocumentState {}

const DocumentStore: Module<DocumentState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getDocuments(ctx, payload: { customerId: number; query?: LocationQuery }) {
         return await service.getDocuments(payload.customerId, payload.query);
      },
      async createDocument(ctx, payload: { customerId: number; data: UploadCustomerDocumentDTO }) {
         return await service.postDocument(payload.customerId, payload.data);
      },
      async deleteDocument(ctx, payload: { customerId: number; documentId: number }) {
         return await service.deleteDocument(payload.customerId, payload.documentId);
      },
      async getDocumentUrls(ctx, payload: { customerId: number; documentIds: Array<number> }) {
         return await service.getDocumentUrls(payload.customerId, payload.documentIds);
      },
   },
};

export default DocumentStore;
